export { default } from '@triptyk/ember-utils/services/download-file';
